import { render, staticRenderFns } from "./HLFormLoginRegister.vue?vue&type=template&id=05bac862&"
import script from "./HLFormLoginRegister.vue?vue&type=script&lang=js&"
export * from "./HLFormLoginRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports